export default __webpack_public_path__ + "static/media/medical-background.7f7fb746.jpg";